import React from "react";

import { Experience } from "@src/store/slices/experiences/types";
import { useIsMutating } from "@tanstack/react-query";

import { ActionExperienceButton } from "./ActionExperienceButton";

interface HaltExperienceButtonProps {
  rowExperience: Experience;
  currentExperience?: Experience;
  onActionExpButtonClick: (experiment: Experience) => void;
  action: "pause" | "end";
  renderLocation: "overview" | "experience";
  hasSchedule: boolean;
  onPauseExp?: (experience: Experience) => void;
}

export const HaltExperienceButton = ({
  rowExperience,
  currentExperience,
  onActionExpButtonClick,
  action,
  renderLocation,
  hasSchedule,
  onPauseExp,
}: HaltExperienceButtonProps) => {
  const isStartExperimentMutating = useIsMutating({
    mutationKey: ["startExperience"],
  });
  const isEndExperimentMutating = useIsMutating({
    mutationKey: ["endExperience"],
  });
  const isPauseExperimentMutating = useIsMutating({
    mutationKey: ["pauseExperience"],
  });

  // no gating because you should always be able to end/pause
  return (
    <ActionExperienceButton
      renderLocation={renderLocation}
      isLoading={
        Boolean(
          isStartExperimentMutating ||
          isEndExperimentMutating ||
          isPauseExperimentMutating
        ) && rowExperience.id === currentExperience?.id
      }
      onClick={() => {
        onActionExpButtonClick(rowExperience);
      }}
      disabled={false}
      action={action}
      experience={rowExperience}
      hasSchedule={hasSchedule}
      onPauseExp={onPauseExp}
    />
  );
};
